/**
 * Runtime environment configuration helper
 * Reads from window.__ENV__ (injected at runtime) with a build-time fallback.
 */
const buildTimeEnv = {
  REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  REACT_APP_WS_URL: process.env.REACT_APP_WS_URL,
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  REACT_APP_RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};

export const getEnv = (key) => {
  // Runtime config takes precedence (for Docker deployments)
  if (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__[key] !== undefined) {
    return window.__ENV__[key];
  }
  return buildTimeEnv[key];
};

// Convenience exports for commonly used variables
export const ENV = {
  get BACKEND_URL() {
    return getEnv('REACT_APP_BACKEND_URL');
  },
  get WS_URL() {
    return getEnv('REACT_APP_WS_URL');
  },
  get ENVIRONMENT() {
    return getEnv('REACT_APP_ENVIRONMENT');
  },
  get RECAPTCHA_SITE_KEY() {
    return getEnv('REACT_APP_RECAPTCHA_SITE_KEY');
  },
};
